module.exports = __WEBPACK_EXTERNAL_MODULE_84__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"clappr","commonjs":"clappr","commonjs2":"clappr","root":"Clappr"}
// module id = 84
// module chunks = 0